module.exports = __webpack_public_path__ + "img/qrcode.103285d8.png";